module.exports = __webpack_public_path__ + "static/img/server_develop.8465eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/server_develop.jpg
// module id = Zt5Z
// module chunks = 1